import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ModalService } from '@core/services/modal/modal.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-amo-guides',
    templateUrl: './user-rotation-guides.component.html',
    styleUrls: ['./user-rotation-guides.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class AmoGuidesComponent implements OnInit {
    content: any;

    data = {
        title: '',
        header: '',
        topMessage: '',
        bottomMessage: '',
        icon: '',
        color: '',
        lines: 2,
        class: '',
    };

    constructor(
        private modalService: ModalService,
        private toolService: ToolService
    ) {}

    ngOnInit() {
        this.toolService.content.subscribe((response: any) => {
            this.content = response;
        });
    }

    openInformationModal(type: string) {
        if (type === 'support') {
            this.data.bottomMessage = this.content.user.components.amoGuides.modalContent.support;
            this.data.class = 'sidebar-modal-sm';
        } else if (type === 'predeparture') {
            this.data.bottomMessage = this.content.user.components.amoGuides.modalContent.predeparture;
            this.data.class = 'sidebar-modal-xs';
        } else if (type === 'orientation') {
            this.data.topMessage = this.content.user.components.amoGuides.modalContent.orientationTop;
            this.data.bottomMessage = this.content.user.components.amoGuides.modalContent.orientationBottom;
            this.data.class = 'sidebar-modal';
        } else if (type === 'resource') {
            this.data.topMessage = this.content.user.components.amoGuides.modalContent.resourcesTop;
            this.data.bottomMessage = this.content.user.components.amoGuides.modalContent.resourcesBottom;
            this.data.class = 'sidebar-modal-sm';
        } else if (type === 'additional') {
            this.data.bottomMessage = this.content.user.components.amoGuides.modalContent.additional;
            this.data.class = 'sidebar-modal-xs';
        } else if (type === 'lor') {
            this.data.bottomMessage = this.content.user.components.amoGuides.modalContent.lor;
            this.data.class = 'sidebar-modal-lg';
        }

        this.modalService.basicInfoAlert(this.data).then((response: any) => {
            this.data.topMessage = '';
            this.data.bottomMessage = '';
            this.data.class = '';
        });
    }
}
